import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/system";

const HeaderContainer = styled.div`
	padding-bottom: 10px;
	margin-left: 0px;
`;

const PageContent = styled.div`
	display: flex;
	width: calc(100% - 20px);
	min-height: calc(100vh - 71px);
	flex-direction: column;
	padding: 10px;
`;

const CircularProgressWrapper = styled.div`
	margin: 0px auto;
	margin-top: 300px;
`;

const HeaderContent = styled.div`
	display: flex;
	column-gap: 20px;
`;

const PageTitleContent = styled.div``;

const ApplicationPageTemplate = ({ title, description, toolbar, children, pageReady, icon }) => {
	return (
		<PageContent>
			{!pageReady ? (
				<CircularProgressWrapper>
					<CircularProgress />
				</CircularProgressWrapper>
			) : (
				<>
					<HeaderContainer>
						<HeaderContent>
							<PageTitleContent>
								{icon && <img src={icon} alt="AppIcon" />}
								<Typography variant="h5" gutterBottom component="div" style={{}}>
									{title}
								</Typography>
								{description && (
									<Typography variant="body2" gutterBottom component="div">
										{description}
									</Typography>
								)}
							</PageTitleContent>
							<Box style={{ flexGrow: 4 }}></Box>
							{toolbar && <Box style={{ display: "flex", alignItems: "end", columnGap: "10px" }}>{toolbar}</Box>}
						</HeaderContent>
					</HeaderContainer>
					{children}
				</>
			)}
		</PageContent>
	);
};

export default ApplicationPageTemplate;
